import '@/styles/globals.css'
import '@/styles/kitchen.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Sora } from 'next/font/google'

const sora = Sora({
    subsets: ['latin'],
    weight: ['300', '400', '500', '600', '700', '800']
})

const fontVariables = `:root{--font-app-sans:${sora.style.fontFamily};--font-app-mono:${sora.style.fontFamily};--font-app-heading:${sora.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='font-sans'>
            <Head>
                <meta name='viewport' content='width=device-width, initial-scale=1' />
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
